import './Events.css';

export default function Events() {
    return (<div id="events" className="section">
        <h1>Events</h1>
        <p>
        Coming soon...
        </p>
    </div>)
}